import styled from "styled-components";

type BackgroundProp = {
  bg?: string;
};

export const Approval = styled.div<BackgroundProp>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  border-radius: 8px;
  background-color: ${(props) => props.bg};
  padding: 8px;
  width: 100%;
  min-width: 0;
`;

export const ApprovalSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: flex-start;
`;

export const BadgeIdContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
`;

export const StatusBadge = styled.div<BackgroundProp>`
  padding: 6px 8px;
  border-radius: 72px;
  background-color: ${(props) => props.bg ?? "black"};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const ImagesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
`;

export const SignatureImageDisplay = styled.img`
  height: 18px;
  width: auto;
  object-fit: contain;
`;

export const LoadingText = styled.div`
  font-size: 12px;
  color: #6c757d;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 0 8px;
`;

export const CommentText = styled.p`
  font-size: 14px;
  color: #343a40;
  white-space: pre-wrap;
  margin: 0;
  line-height: 1.6;
  font-weight: 400;
`;

export const ApprovalHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;
